import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 'calc(100% - 32px)',
        maxWidth: 564,
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const Content = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
});

export const FieldContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
});
